import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_CERTIFICATION',
  name: 'Workspace Project Certification',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: '_fileIds', title: 'Files' },
    { key: '_standardId', title: 'Standard' },
    { key: 'status', title: 'Status' },
    { key: 'type', title: 'Type' },
    { key: 'certification', title: 'Certification' },
    { key: 'validator', title: 'Validator' },
    { key: 'registryLink', title: 'Registry link' },
    { key: 'createdAt', title: 'Date created' },
    { key: 'updatedAt', title: 'Date updated' },
  ],
  actions: ['READ', 'CREATE', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
